import React from 'react';
import { Input } from '../../components/primitives';


type CategorySingleFilter = {
    category: any;
    index: any;
    categoryFilter: any;
    setCategoryFilter: (category: any) => void;
};

export default function CategorySingleFilter(props: CategorySingleFilter) {
    const { category, categoryFilter, setCategoryFilter, index } = props;

    const capitalizeFirstLetter = (sentence: any) => {
        if (typeof sentence !== 'string') return '';
        return sentence.charAt(0).toUpperCase() + sentence.slice(1);
    };

    return (
        <>
            {category.id.split('/')[3] ? (
                <label>
                    <Input
                        type='checkbox'
                        checked={categoryFilter.includes(category.id)}
                        onChange={() => {
                            categoryFilter.includes(category.id)
                                ? setCategoryFilter(
                                      categoryFilter.filter(
                                          (cat: any) => cat !== category.id
                                      )
                                  )
                                : setCategoryFilter([
                                      ...categoryFilter,
                                      category.id,
                                  ]);
                        }}
                    />
                    {capitalizeFirstLetter(category.name)}
                </label>
            ) : (
                <h4 className='filterName'>{category.name.toUpperCase()}</h4>
            )}
        </>
    );
}
